<isp-select
  [id]="id"
  [formlyAttributes]="field"
  [required]="props.required"
  [multiple]="props.multiple"
  [placeholder]="props.placeholder$ | async"
  [anchorType]="props.anchorType"
  [anchorWidth]="props.anchorWidth"
  [anchorTextFuncHTML]="props.anchorTextFuncHTML"
  [anchorTextFunc]="props.anchorTextFunc"
  [listWidth]="props.listWidth$ | async"
  [notFoundText]="props.notFoundText$ | async"
  [selectAllText]="props.selectAllText$ | async"
  [confirmMsg]="props.confirmMsg"
  [resetMsg]="props.resetMsg"
  [displayClear]="props.displayClear"
  [dropdownPopupClass]="'isp-dynamic-form-select-dropdown-popup'"
  [dropdownParentSelector]="props.dropdownParentSelector | formIdPrefix"
  [dropdownDirection]="props.dropdownDirection"
  [dropdownScrollSelector]="props.dropdownScrollSelector"
  [options]="props.optionsUi$ | async"
  [formControl]="formControl"
  (ngModelChange)="onModelChange($event)"
  #select
></isp-select>
